'use strict';

angular.module('app').directive('loginPopup', function($http, $compile, $timeout, $location, Auth, diviacLocalStorage, GTM) {
    function link(scope) {

        if (Auth.getUser()) {
            return true;
        }

        if (!scope.abShow) {
            scope.abShow = 2;
        }

        if (scope.abShow === 1) {
            GTM.variables({
                'user_experiment_1': 'registration-popup-monitor'
            });

            return true;
        }

        function showPopup(template) {
            if (Auth.getUser() || diviacLocalStorage.get('login-popup') || jQuery.fancybox.isOpen || $location.path() === '/sweepstake/enter/') {
                return true;
            }

            diviacLocalStorage.set('login-popup', true);
            GTM.event('registration_popup_open');

            jQuery.fancybox({
                content: template,
                type: 'html',
                padding: 40,
                wrapCSS: 'form-popup registration-popup',
                maxWidth: '1000',
                beforeShow: function() {},
                afterClose: function() {
                    GTM.event('registration_popup_close');
                },
                afterShow: function() {}
            });
        }

        $http.get('templates/_login-popup.html').then(function(response) {
            if (response.status === 200) {
                var template = $compile(angular.element(response.data))(scope);

                if (scope.abShow === 2) {
                    GTM.variables({
                        'user_experiment_1': 'registration-popup-v2'
                    });

                    $(document).on('mouseleave', function(e) {
                        if (e.clientY < 0) {
                            showPopup(template);
                        }
                    });
                } else {
                    $timeout(function() {
                        GTM.variables({
                            'user_experiment_1': 'registration-popup-v1'
                        });

                        showPopup(template);
                    }, 30000);
                }
            }
        });
    }

    return {
        restrict: 'A',
        scope: {
            abShow: '='
        },
        link: link
    };
});